<!--视频列表-->
<template>
  <Card :bordered="true" dis-hover>
    <p slot="title">
      <slot name="title"></slot>
    </p>
    <!-- <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a> -->
    <div class="video-list">
      <div class="video-item" v-for="video in videoList" :key="video.id">
        <figure>
          <a v-if="video.url">
            <img class="video-img video-body" :src="video.url" v-if="video.url" />
          </a>
          <span class="no-video video-body" v-else>
            <!-- <i class="iconfont icon-newicon-shipinxundian"></i> -->
            <img src="../../../../public/images/home/no-img.png" alt="" />
          </span>
          <figcaption>{{ video.name }}</figcaption>
        </figure>
      </div>
    </div>
    <!--  <Carousel
      v-model="swiperValue"
      class="video-carousel"
      :height="234"
      arrow="never"
      dots="none"
      autoplay
      :autoplay-speed="5000"
    >
      <CarouselItem v-for="(video, index) in videoList" :key="index">
        <video
          width="100%"
          height="100%"
          :id="'video' + index"
          autoplay
          muted
          crossorigin="*"
          controlslist="nodownload"
          :autoplay-speed="5000"
        ></video>
      </CarouselItem>
    </Carousel> -->
    <Modal
      v-model="showModal"
      :title="$t('home.modal_title')"
      :width="336"
      :mask-closable="false"
      :mask="false"
      :footer-hide="true"
      class-name="expired-modal"
      @on-cancel="showModal = false"
    >
      <div class="expired-tip">{{ $t('home.expired_tip') }}</div>
    </Modal>
  </Card>
</template>

<script>
// import flvjs from 'flv.js';
// import { FLV_CONFIG } from '../config';
import api from '../../../api/home/index';
export default {
  props: {
    tag: {
      require: true,
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      videoList: [],
      showModal: false, // 显示门店过期提醒弹框
      swiperValue: 0,
      isEnterpriseForV3: false, // 是否直接跳转视频巡店3.0
    };
  },
  computed: {
    userInfo() {
      return this.$system.$state.userInfo;
    },
    /**
     * 点击设备 跳转的链接
     */
    videoPageUrl() {
      let domain = this.$system.$state.servers['shopwebUrl'];
      let isMiniso = domain.indexOf('miniso') !== -1;
      if (!isMiniso && this.$https) {
        domain = this.$system.$state.servers['shopwebUrl'].replace('https', 'http');
      }
      return `${domain}${
        this.isEnterpriseForV3 || this.$system.$state.baseInfo.isAdmin
          ? '/video-flv-v3/index.html'
          : '/video-flv/index.html'
      }`;
    },
  },
  mounted() {
    this.getData();
    api.getEnterpriseConfigNew({ groupId: this.userInfo.groupId }).then(res => {
      this.isEnterpriseForV3 = res.videoStoreThree ? true : false;
    });
  },
  methods: {
    async getData() {
      let result = null;
      if (this.tag.tagType === 1) {
        //收藏
        result = await api.getFavoriteTagDetail();
        let videoList = [];
        result.shops.reduce((x, shop) => {
          let video = { id: shop.id, name: shop.name, url: '' };
          if (shop.devices && shop.devices.length > 0) {
            video.url = shop.thumbUrl; //设备缩略图
            video.videoId = shop.devices[0].id;
            video.accessType = shop.devices[0].accessType; //设备的接入类型
            video.thirdpartType = shop.devices[0].thirdpartType; //设备的类型
            video.validateStatus = shop.validateStatus; // 门店状态
          }
          videoList.push(video);
          return videoList;
        }, videoList);
        this.videoList = videoList;
        // this.getVideoUrl(videoList);
      } else if (this.tag.tagType === 2) {
        //最近观看
        // result1 = await api.getRecentViewTagDetail();
        // 换接口，之前是门店维度，现在换成设备维度
        result = await api.getUserRecentViewDetail({
          userId: this.userInfo.id,
        });
        if (!result || !result.length) return;

        this.videoList = result.slice(0, 8).map(ele => {
          let video = {};
          video.url = ele.thumbUrl; //设备缩略图
          video.videoId = ele.id;
          video.name = ele.name;
          // video.accessType = ele.accessType; //设备的接入类型
          video.thirdpartType = ele.thirdpartType; //设备的类型
          video.validateStatus = ele.validateStatus; // 门店状态
          return video;
        });
      }
    },
    async getVideoUrl(videoList) {
      Promise.allSettled(
        videoList.map(i => {
          return api.startNewMediaPlay({
            deviceId: i.videoId,
            isSlave: 0,
            realPlayType: 1,
          });
        })
      ).then(res => {
        videoList.forEach((i, index) => {
          i.videoUrl = (res[index].value && res[index].value.flv) || '';
        });
        this.playVideo(videoList);
      });
    },
    /*  playVideo(videoList) {
      this.videoList = videoList.filter(i => i.videoUrl != '');
      this.$nextTick(() => {
        this.videoList.forEach((item, index) => {
          let player = flvjs.createPlayer(
            {
              type: 'flv', //指定播放的视频类型
              cors: true, //是否启用CORS进行http提取
              isLive: true, //是否为直播流
              url: item.videoUrl, //视频的播放地址
              segments: [
                {
                  cors: true,
                  timestampBase: 0,
                  url: item.videoUrl,
                  withCredentials: false,
                },
              ],
            },
            FLV_CONFIG
          );
          let videoElement = document.getElementById('video' + index);
          player.attachMediaElement(videoElement);
          player.load();
        });
      });
    }, */
    //跳转到视频浏览界面
    goToVideo(videoInfo) {
      // 门店已过期
      if (videoInfo.validateStatus === 1) {
        this.showModal = true;
        return;
      }
      if (!videoInfo.videoId) {
        this.$Message.error(this.$t('home.notexit_curdevice'));
        return false;
      }
      //特定的设备类型和设备接入方式才能跳转新页面
      if (videoInfo.thirdpartType == 11 || videoInfo.thirdpartType == 5 || videoInfo.thirdpartType == 21) {
        this.$system.goRouter({
          router: {
            //路由跳转信息,必填
            // eslint-disable-next-line no-undef
            system: ccconstants.SYSTEM_NOS.Web_Angular_Video_Flv, //系统编号，用于辨识该功能模块现在做在哪个系统里面
            query: {
              id: videoInfo.videoId, //视频设备的Id
              type: videoInfo.thirdpartType, //设备的类型
            },
          },
        });
      } else if (videoInfo.thirdpartType == 0) {
        if (videoInfo.accessType == 1 || videoInfo.accessType == 2 || videoInfo.accessType == 3) {
          this.$system.goRouter({
            router: {
              //路由跳转信息,必填
              // eslint-disable-next-line no-undef
              system: ccconstants.SYSTEM_NOS.Web_Angular_Video_Flv, //系统编号，用于辨识该功能模块现在做在哪个系统里面
              query: {
                id: videoInfo.videoId, //视频设备的Id
                type: videoInfo.thirdpartType, //设备的类型
              },
            },
          });
        } else {
          this.$system.goRouter({
            router: {
              //路由跳转信息,必填
              // eslint-disable-next-line no-undef
              system: ccconstants.SYSTEM_NOS.Web_Angular_Video, //系统编号，用于辨识该功能模块现在做在哪个系统里面
              query: {
                id: videoInfo.videoId, //视频设备的Id
              },
            },
          });
        }
      }
    },
    goToVideoNew(videoInfo) {
      if (videoInfo.validateStatus === 1) {
        this.showModal = true;
        return;
      }
      if (!videoInfo.videoId) {
        this.$Message.error(this.$t('home.notexit_curdevice'));
        return false;
      }
      // 跳转到远程巡店
      let param = { id: videoInfo.videoId };
      if (!this.isEnterpriseForV3) {
        // 不是 直接跳转视频巡店3.0的企业
        param.type = videoInfo.thirdPartType;
      }
      this.openPage(this.videoPageUrl, param, true);
    },
    openPage(url, params, isBlank) {
      let search = '';
      if (params && JSON.stringify(params) !== '{}') {
        search += '?';
        let i = 0;
        for (let key in params) {
          let param = params[key];
          if (i > 0) search += '&';
          search += `${key}=${param}`;
          i++;
        }
      }
      if (isBlank) {
        window.open(`${url}${search}`, '_blank');
      } else {
        window.location.href = `${url}${search}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .ivu-card-body {
    padding-top: 0;
    overflow-y: auto;
  }
}
.video-list {
  width: 100%;
  padding: 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
  color: #999999;
  .video-item {
    margin: 10px 10px 0 10px;
    font-size: 13px;
    figure {
      width: 106px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      figcaption {
        width: 100%;
        box-sizing: border-box;
        padding: 5px 0;
        font-size: $fontsize12;
        @include ellipsis;
      }
      .video-img {
        display: block;
        &:hover {
          border: 1px solid $primary-color-hover;
        }
      }
      .no-video {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f2f2f2;
        img {
          width: 32px;
        }
      }
      .video-body {
        width: 100%;
        height: 60px;
      }
    }
  }
}
.expired-modal {
  .ivu-modal-header-inner {
    font-size: 16px;
  }
  .expired-tip {
    font-size: 13px;
  }
}
@media screen and (min-width: 300px) and (max-width: 768px) {
  .video-list {
    .video-item {
      margin: 5px 5px 0 5px;
      figure {
        width: 80px;
        .video-body {
          height: 45px;
        }
      }
    }
  }
}
.video-carousel {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
</style>
